//#region src/api/generated/core/bodySerializer.gen.ts
var e = (e, t, n) => {
	typeof n == "string" || n instanceof Blob ? e.append(t, n) : n instanceof Date ? e.append(t, n.toISOString()) : e.append(t, JSON.stringify(n));
}, t = { bodySerializer: (t) => {
	let n = new FormData();
	return Object.entries(t).forEach(([t, r]) => {
		r != null && (Array.isArray(r) ? r.forEach((r) => e(n, t, r)) : e(n, t, r));
	}), n;
} }, n = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/api/generated/core/serverSentEvents.gen.ts
function r({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n?/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				await f(Math.min(c * 2 ** (p - 1), s ?? 3e4));
			}
		}
	}() };
}
//#endregion
//#region src/api/generated/core/pathSerializer.gen.ts
var i = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, a = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, o = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, s = ({ allowReserved: e, explode: t, name: n, style: r, value: o }) => {
	if (!t) {
		let t = (e ? o : o.map((e) => encodeURIComponent(e))).join(a(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = i(r), l = o.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : c({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + l : l;
}, c = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, l = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let s = o(r), l = Object.entries(i).map(([t, i]) => c({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(s);
	return r === "label" || r === "matrix" ? s + l : l;
}, u = /\{[^{}]+\}/g, d = ({ path: e, url: t }) => {
	let n = t, r = t.match(u);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, s({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, l({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${c({
				name: i,
				value: o
			})}`);
			continue;
		}
		let u = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, u);
	}
	return n;
}, f = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = d({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function p(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/api/generated/core/auth.gen.ts
var m = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, h = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = s({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = l({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = c({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ee = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, g = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1;
async function te(e) {
	for (let t of e.security ?? []) {
		if (g(e, t.name)) continue;
		let n = await m(t, e.auth);
		if (!n) continue;
		let r = t.name ?? "Authorization";
		switch (t.in) {
			case "query":
				e.query ||= {}, e.query[r] = n;
				break;
			case "cookie":
				e.headers.append("Cookie", `${r}=${n}`);
				break;
			default:
				e.headers.set(r, n);
				break;
		}
	}
}
var _ = (e) => f({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : h(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = b(e.headers, t.headers), n;
}, y = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, b = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? y(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, x = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, S = () => ({
	error: new x(),
	request: new x(),
	response: new x()
}), C = h({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), w = { "Content-Type": "application/json" }, T = (e = {}) => ({
	...n,
	headers: w,
	parseAs: "auto",
	querySerializer: C,
	...e
}), E = ((e = {}) => {
	let t = v(T(), e), n = () => ({ ...t }), i = (e) => (t = v(t, e), n()), a = S(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: b(t.headers, e.headers),
			serializedBody: void 0
		};
		n.security && await te(n), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type");
		let r = n;
		return {
			opts: r,
			url: _(r)
		};
	}, s = async (e) => {
		let n = e.throwOnError ?? t.throwOnError, r = e.responseStyle ?? t.responseStyle, i, s;
		try {
			let { opts: t, url: n } = await o(e), r = {
				redirect: "follow",
				...t,
				body: p(t)
			};
			i = new Request(n, r);
			for (let e of a.request.fns) e && (i = await e(i, t));
			let c = t.fetch;
			s = await c(i);
			for (let e of a.response.fns) e && (s = await e(s, i, t));
			let l = {
				request: i,
				response: s
			};
			if (s.ok) {
				let e = (t.parseAs === "auto" ? ee(s.headers.get("Content-Type")) : t.parseAs) ?? "json";
				if (s.status === 204 || s.headers.get("Content-Length") === "0") {
					let n;
					switch (e) {
						case "arrayBuffer":
						case "blob":
						case "text":
							n = await s[e]();
							break;
						case "formData":
							n = new FormData();
							break;
						case "stream":
							n = s.body;
							break;
						default:
							n = {};
							break;
					}
					return t.responseStyle === "data" ? n : {
						data: n,
						...l
					};
				}
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "formData":
					case "text":
						n = await s[e]();
						break;
					case "json": {
						let e = await s.text();
						n = e ? JSON.parse(e) : {};
						break;
					}
					case "stream": return t.responseStyle === "data" ? s.body : {
						data: s.body,
						...l
					};
				}
				return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let u = await s.text(), d;
			try {
				d = JSON.parse(u);
			} catch {}
			throw d ?? u;
		} catch (t) {
			let o = t;
			for (let t of a.error.fns) t && (o = await t(o, s, i, e));
			if (o ||= {}, n) throw o;
			return r === "data" ? void 0 : {
				error: o,
				request: i,
				response: s
			};
		}
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: i } = await o(t);
		return r({
			...n,
			body: n.body,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: p(n),
			url: i
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: i,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(T({
	baseUrl: "http://localhost:2023",
	throwOnError: !0
})), D = (e) => (e?.client ?? E).get({
	url: "/api/admin/billing-catalog",
	...e
}), O = (e) => (e?.client ?? E).post({
	url: "/api/admin/billing-catalog/sync",
	...e
}), k = (e) => (e.client ?? E).patch({
	url: "/api/admin/billing-catalog/products/{id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), A = (e) => (e.client ?? E).post({
	url: "/api/admin/billing/advance-subscription",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), j = (e) => (e?.client ?? E).put({
	url: "/api/admin/platform-settings",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), M = (e) => (e?.client ?? E).get({
	url: "/api/admin/coach-products-fees",
	...e
}), N = (e) => (e.client ?? E).put({
	url: "/api/admin/coach-products-fees/{userId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), P = (e) => (e?.client ?? E).get({
	url: "/api/admin/app-features",
	...e
}), F = (e) => (e.client ?? E).post({
	url: "/api/admin/app-features",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), I = (e) => (e.client ?? E).delete({
	url: "/api/admin/app-features/{key}",
	...e
}), L = (e) => (e.client ?? E).patch({
	url: "/api/admin/app-features/{key}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), R = (e) => (e?.client ?? E).get({
	url: "/api/admin/feature-flags",
	...e
}), z = (e) => (e.client ?? E).post({
	url: "/api/admin/feature-flags",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), B = (e) => (e.client ?? E).delete({
	url: "/api/admin/feature-flags/{flagName}",
	...e
}), V = (e) => (e.client ?? E).patch({
	url: "/api/admin/feature-flags/{flagName}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), H = (e) => (e?.client ?? E).get({
	url: "/api/admin/feature-flag-assignments",
	...e
}), U = (e) => (e.client ?? E).post({
	url: "/api/admin/feature-flag-assignments",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), W = (e) => (e.client ?? E).delete({
	url: "/api/admin/feature-flag-assignments/{assignmentId}",
	...e
}), G = (e) => (e?.client ?? E).get({
	url: "/api/admin/users",
	...e
}), K = (e) => (e?.client ?? E).get({
	url: "/api/ai",
	...e
}), q = (e) => (e?.client ?? E).post({
	url: "/api/ai",
	...e
}), J = (e) => (e.client ?? E).get({
	url: "/api/ai/{chatId}",
	...e
}), Y = (e) => (e.client ?? E).post({
	url: "/api/ai/{chatId}/messages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), X = (e) => (e.client ?? E).get({
	url: "/api/ai/{chatId}/stream",
	...e
}), Z = (e) => (e.client ?? E).post({
	url: "/api/ai/{chatId}/abort",
	...e
}), Q = (e) => (e.client ?? E).get({
	url: "/api/app-releases",
	...e
}), ne = (e) => (e.client ?? E).get({
	url: "/api/athlete-invitations/{invitationId}",
	...e
}), re = (e) => (e.client ?? E).post({
	url: "/api/athlete-invitations/{invitationId}/accept",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ie = (e) => (e.client ?? E).post({
	...t,
	url: "/api/chat/upload-media",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), ae = (e) => (e.client ?? E).delete({
	url: "/api/chat/upload-media/{fileId}",
	...e
}), oe = (e) => (e?.client ?? E).get({
	url: "/api/chat/chats",
	...e
}), se = (e) => (e?.client ?? E).get({
	url: "/api/chat/list",
	...e
}), ce = (e) => (e?.client ?? E).get({
	url: "/api/chat/possible-participants",
	...e
}), le = (e) => (e.client ?? E).post({
	url: "/api/chat/direct-chats",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ue = (e) => (e.client ?? E).get({
	url: "/api/chat/chats/{chatId}",
	...e
}), de = (e) => (e.client ?? E).get({
	url: "/api/chat/chats/{chatId}/messages",
	...e
}), fe = (e) => (e.client ?? E).post({
	url: "/api/chat/chats/{chatId}/messages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), pe = (e) => (e.client ?? E).delete({
	url: "/api/chat/messages/{messageId}",
	...e
}), me = (e) => (e.client ?? E).patch({
	url: "/api/chat/messages/{messageId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), he = (e) => (e.client ?? E).post({
	url: "/api/chat/chats/{chatId}/read",
	...e
}), ge = (e) => (e.client ?? E).post({
	url: "/api/chat/chats/{chatId}/unread",
	...e
}), _e = (e) => (e.client ?? E).post({
	url: "/api/coaches/athlete-invitations",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ve = (e) => (e.client ?? E).patch({
	url: "/api/coaches/me",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ye = (e) => (e?.client ?? E).get({
	url: "/api/athletes/dashboard",
	...e
}), be = (e) => (e?.client ?? E).get({
	url: "/api/athletes/filters",
	...e
}), xe = (e) => (e?.client ?? E).post({
	url: "/api/athletes/filters",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Se = (e) => (e.client ?? E).delete({
	url: "/api/athletes/filters/{filterId}",
	...e
}), Ce = (e) => (e?.client ?? E).get({
	url: "/api/athletes",
	...e
}), we = (e) => (e.client ?? E).put({
	url: "/api/athletes/{athleteId}/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Te = (e) => (e.client ?? E).patch({
	url: "/api/athletes/{athleteId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ee = (e) => (e.client ?? E).get({
	url: "/api/athletes/{athleteId}/profile",
	...e
}), De = (e) => (e.client ?? E).patch({
	url: "/api/athletes/{athleteId}/profile",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Oe = (e) => (e.client ?? E).get({
	url: "/api/athletes/{athleteId}/programs/{programId}",
	...e
}), ke = (e) => (e.client ?? E).get({
	url: "/api/athletes/{athleteId}/questionnaires",
	...e
}), Ae = (e) => (e.client ?? E).post({
	url: "/api/athletes/{athleteId}/archive",
	...e
}), je = (e) => (e.client ?? E).post({
	url: "/api/athletes/{athleteId}/restore",
	...e
}), Me = (e) => (e.client ?? E).post({
	url: "/api/auth/register",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ne = (e) => (e.client ?? E).post({
	url: "/api/auth/password-reset",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Pe = (e) => (e.client ?? E).post({
	url: "/api/auth/register/verify-email",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Fe = (e) => (e.client ?? E).post({
	url: "/api/auth/authenticate",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ie = (e) => (e?.client ?? E).get({
	url: "/api/auth/authorize",
	...e
}), Le = (e) => (e?.client ?? E).get({
	url: "/api/auth/status",
	...e
}), Re = (e) => (e?.client ?? E).get({
	url: "/api/automations",
	...e
}), ze = (e) => (e.client ?? E).post({
	url: "/api/automations",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Be = (e) => (e.client ?? E).get({
	url: "/api/automations/{automationId}/runs",
	...e
}), Ve = (e) => (e.client ?? E).delete({
	url: "/api/automations/{automationId}",
	...e
}), He = (e) => (e.client ?? E).get({
	url: "/api/automations/{automationId}",
	...e
}), Ue = (e) => (e.client ?? E).put({
	url: "/api/automations/{automationId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), We = (e) => (e.client ?? E).get({
	url: "/api/calendar",
	...e
}), Ge = (e) => (e?.client ?? E).post({
	url: "/api/calendar",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Ke = (e) => (e.client ?? E).get({
	url: "/api/calendar/athletes/{athleteId}",
	...e
}), qe = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/workouts/bulk-copy",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Je = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/workouts/assign-program",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ye = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/calendar-items/bulk-delete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Xe = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/calendar-items/bulk-move",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ze = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/workout-items/bulk-delete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Qe = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/workout-items/bulk-copy",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), $e = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/workouts/{calendarItemId}/export-to-library",
	...e
}), et = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/week/duplicate",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), tt = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/week/clear",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), nt = (e) => (e.client ?? E).get({
	url: "/api/calendar/athletes/{athleteId}/phases",
	...e
}), rt = (e) => (e.client ?? E).post({
	url: "/api/calendar/athletes/{athleteId}/phases",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), it = (e) => (e.client ?? E).delete({
	url: "/api/calendar/athletes/{athleteId}/phases/{phaseId}",
	...e
}), at = (e) => (e.client ?? E).put({
	url: "/api/calendar/athletes/{athleteId}/phases/{phaseId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ot = (e) => (e.client ?? E).post({
	url: "/api/calendar/materialize",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), st = (e) => (e.client ?? E).post({
	url: "/api/calendar/visibility",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ct = (e) => (e.client ?? E).patch({
	url: "/api/calendar/{calendarItemId}/move",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), lt = (e) => (e.client ?? E).get({
	url: "/api/calendar/{calendarItemId}",
	...e
}), ut = (e) => (e.client ?? E).patch({
	url: "/api/calendar/{calendarItemId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), dt = (e) => (e.client ?? E).patch({
	url: "/api/calendar/{calendarItemId}/discard",
	...e
}), ft = (e) => (e.client ?? E).patch({
	url: "/api/calendar/{calendarItemId}/finish",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), pt = (e) => (e.client ?? E).get({
	url: "/api/comments/comment-groups",
	...e
}), mt = (e) => (e.client ?? E).get({
	url: "/api/comments/author-comments",
	...e
}), ht = (e) => (e?.client ?? E).post({
	url: "/api/comments",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), gt = (e) => (e.client ?? E).post({
	url: "/api/comments/mark-as-read",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), _t = (e) => (e?.client ?? E).get({
	url: "/api/content-hub/hubs",
	...e
}), vt = (e) => (e?.client ?? E).post({
	url: "/api/content-hub/hubs",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), yt = (e) => (e.client ?? E).post({
	url: "/api/content-hub/hubs/{contentHubId}/copy",
	...e
}), bt = (e) => (e.client ?? E).delete({
	url: "/api/content-hub/hubs/{contentHubId}",
	...e
}), xt = (e) => (e.client ?? E).get({
	url: "/api/content-hub/hubs/{contentHubId}",
	...e
}), St = (e) => (e.client ?? E).put({
	url: "/api/content-hub/hubs/{contentHubId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ct = (e) => (e.client ?? E).get({
	url: "/api/content-hub/hubs/{contentHubId}/deletion-impact",
	...e
}), wt = (e) => (e.client ?? E).get({
	url: "/api/content-hub/hubs/{contentHubId}/assignments",
	...e
}), Tt = (e) => (e.client ?? E).put({
	url: "/api/content-hub/hubs/{contentHubId}/assignments",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Et = (e) => (e?.client ?? E).get({
	url: "/api/content-hub/assigned-hubs",
	...e
}), Dt = (e) => (e.client ?? E).get({
	url: "/api/content-hub/home",
	...e
}), Ot = (e) => (e.client ?? E).delete({
	url: "/api/content-hub/items/{itemId}",
	...e
}), kt = (e) => (e.client ?? E).get({
	url: "/api/content-hub/items/{itemId}",
	...e
}), At = (e) => (e.client ?? E).put({
	url: "/api/content-hub/items/{itemId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), jt = (e) => (e?.client ?? E).post({
	url: "/api/content-hub/items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Mt = (e) => (e?.client ?? E).post({
	url: "/api/content-hub/items/batch",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Nt = (e) => (e?.client ?? E).post({
	url: "/api/content-hub/items/reorder",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Pt = (e) => (e.client ?? E).post({
	url: "/api/content-hub/items/{itemId}/move",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ft = (e) => (e?.client ?? E).get({
	url: "/api/exercises",
	...e
}), It = (e) => (e?.client ?? E).post({
	url: "/api/exercises",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Lt = (e) => (e.client ?? E).post({
	url: "/api/exercises/{exerciseId}/copy",
	...e
}), Rt = (e) => (e.client ?? E).delete({
	url: "/api/exercises/{exerciseId}",
	...e
}), zt = (e) => (e.client ?? E).get({
	url: "/api/exercises/{exerciseId}",
	...e
}), Bt = (e) => (e.client ?? E).patch({
	url: "/api/exercises/{exerciseId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Vt = (e) => (e?.client ?? E).get({
	url: "/api/exercises/muscle-groups",
	...e
}), Ht = (e) => (e?.client ?? E).get({
	url: "/api/exercises/movement-patterns",
	...e
}), Ut = (e) => (e?.client ?? E).get({
	url: "/api/exercises/categories",
	...e
}), Wt = (e) => (e?.client ?? E).get({
	url: "/api/exercises/attributes",
	...e
}), Gt = (e) => (e?.client ?? E).get({
	url: "/api/exercises/history",
	...e
}), Kt = (e) => (e.client ?? E).get({
	url: "/api/exercises/{exerciseId}/history",
	...e
}), qt = (e) => (e.client ?? E).delete({
	url: "/api/exercises/{exerciseId}/images/{imageId}",
	...e
}), Jt = (e) => (e.client ?? E).put({
	url: "/api/exercises/{exerciseId}/alternates",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Yt = (e) => (e.client ?? E).post({
	...t,
	url: "/api/exercises/{exerciseId}/images",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Xt = (e) => (e.client ?? E).post({
	...t,
	url: "/api/exercises/{exerciseId}/video",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Zt = (e) => (e?.client ?? E).post({
	url: "/api/integrations/apple-health/connect",
	...e
}), Qt = (e) => (e?.client ?? E).get({
	url: "/api/integrations/apple-health/config",
	...e
}), $t = (e) => (e?.client ?? E).post({
	url: "/api/integrations/apple-health/disconnect",
	...e
}), en = (e) => (e?.client ?? E).get({
	url: "/api/integrations/apple-health/status",
	...e
}), tn = (e) => (e?.client ?? E).post({
	url: "/api/integrations/apple-health/sync",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), nn = (e) => (e?.client ?? E).post({
	url: "/api/integrations/apple-health/workouts",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), rn = (e) => (e?.client ?? E).get({
	url: "/api/integrations/statuses",
	...e
}), an = (e) => (e?.client ?? E).get({
	url: "/api/integrations/metric-configs",
	...e
}), on = (e) => (e.client ?? E).post({
	url: "/api/integrations/metric-configs",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), sn = (e) => (e.client ?? E).delete({
	url: "/api/integrations/metric-configs/{id}",
	...e
}), cn = (e) => (e?.client ?? E).get({
	url: "/api/integrations/strava/connect-url",
	...e
}), ln = (e) => (e?.client ?? E).get({
	url: "/api/integrations/strava/status",
	...e
}), un = (e) => (e?.client ?? E).post({
	url: "/api/integrations/strava/disconnect",
	...e
}), dn = (e) => (e.client ?? E).post({
	url: "/api/integrations/strava/sync",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), fn = (e) => (e?.client ?? E).delete({
	url: "/api/integrations/strava/webhook-subscription",
	...e
}), pn = (e) => (e?.client ?? E).get({
	url: "/api/integrations/strava/webhook-subscription",
	...e
}), mn = (e) => (e.client ?? E).post({
	url: "/api/integrations/strava/webhook-subscription",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), hn = (e) => (e?.client ?? E).get({
	url: "/api/integrations/strava/activities",
	...e
}), gn = (e) => (e.client ?? E).get({
	url: "/api/integrations/strava/activities/{id}/detail",
	...e
}), _n = (e) => (e?.client ?? E).get({
	url: "/api/labels",
	...e
}), vn = (e) => (e.client ?? E).post({
	url: "/api/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), yn = (e) => (e.client ?? E).get({
	url: "/api/labels/{id}/deletion-impact",
	...e
}), bn = (e) => (e.client ?? E).delete({
	url: "/api/labels/{id}",
	...e
}), xn = (e) => (e.client ?? E).patch({
	url: "/api/labels/{id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Sn = (e) => (e.client ?? E).get({
	url: "/api/mcp-authorizations",
	...e
}), Cn = (e) => (e?.client ?? E).post({
	url: "/api/mcp-authorizations",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), wn = (e) => (e?.client ?? E).post({
	url: "/api/mcp-authorizations/denials",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Tn = (e) => (e?.client ?? E).get({
	url: "/api/mcp-connections",
	...e
}), En = (e) => (e.client ?? E).delete({
	url: "/api/mcp-connections/{connectionId}",
	...e
}), Dn = (e) => (e?.client ?? E).get({
	url: "/api/metrics/available",
	...e
}), On = (e) => (e.client ?? E).get({
	url: "/api/metrics/summary",
	...e
}), kn = (e) => (e.client ?? E).get({
	url: "/api/metrics",
	...e
}), An = (e) => (e.client ?? E).post({
	url: "/api/metrics",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), jn = (e) => (e.client ?? E).patch({
	url: "/api/metrics/{id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Mn = (e) => (e.client ?? E).get({
	url: "/api/metrics/{metricId}/measurements",
	...e
}), Nn = (e) => (e.client ?? E).get({
	url: "/api/metrics/{id}/series",
	...e
}), Pn = (e) => (e.client ?? E).post({
	url: "/api/metrics/measurements",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Fn = (e) => (e.client ?? E).delete({
	url: "/api/metrics/measurements/{measurementId}",
	...e
}), In = (e) => (e.client ?? E).patch({
	url: "/api/metrics/measurements/{measurementId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ln = (e) => (e?.client ?? E).get({
	url: "/api/metrics/me",
	...e
}), Rn = (e) => (e?.client ?? E).get({
	url: "/api/notification-preferences",
	...e
}), zn = (e) => (e?.client ?? E).patch({
	url: "/api/notification-preferences",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Bn = (e) => (e?.client ?? E).get({
	url: "/api/notifications",
	...e
}), Vn = (e) => (e.client ?? E).get({
	url: "/api/notifications/{notificationId}",
	...e
}), Hn = (e) => (e.client ?? E).post({
	url: "/api/notifications/mark-as-read",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Un = (e) => (e.client ?? E).post({
	url: "/api/notifications/mark-as-unread",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Wn = (e) => (e?.client ?? E).post({
	url: "/api/notifications/mark-all-as-read",
	...e
}), Gn = (e) => (e.client ?? E).get({
	url: "/api/organization-member-invitations/{invitationId}",
	...e
}), Kn = (e) => (e.client ?? E).post({
	url: "/api/organization-member-invitations/{invitationId}/accept",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qn = (e) => (e?.client ?? E).get({
	url: "/api/organizations",
	...e
}), Jn = (e) => (e?.client ?? E).post({
	url: "/api/organizations",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Yn = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Xn = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/logo",
	...e
}), Zn = (e) => (e.client ?? E).post({
	...t,
	url: "/api/organizations/{organizationId}/logo",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Qn = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes",
	...e
}), $n = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/athletes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), er = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/metrics",
	...e
}), tr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/metrics/{metricId}/series",
	...e
}), nr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/metrics/measurements",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), rr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/statistics/exercises",
	...e
}), ir = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/statistics/exercises/{exerciseId}",
	...e
}), ar = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/questionnaires",
	...e
}), or = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/questionnaires/available",
	...e
}), sr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/questionnaires/{questionnaireId}/submissions",
	...e
}), cr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/questionnaires/{questionnaireId}/submissions",
	...e
}), lr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/questionnaires/{questionnaireId}/submissions/{submissionId}",
	...e
}), ur = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/profile",
	...e
}), dr = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/profile",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), fr = (e) => (e.client ?? E).put({
	url: "/api/organizations/{organizationId}/athletes/{athleteId}/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), pr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/exercises",
	...e
}), mr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/exercises",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), hr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}/copy",
	...e
}), gr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}",
	...e
}), _r = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}",
	...e
}), vr = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), yr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}/images/{imageId}",
	...e
}), br = (e) => (e.client ?? E).post({
	...t,
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}/images",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), xr = (e) => (e.client ?? E).post({
	...t,
	url: "/api/organizations/{organizationId}/exercises/{exerciseId}/video",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Sr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/members",
	...e
}), Cr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/members",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), wr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/labels",
	...e
}), Tr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Er = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/labels/{labelId}/deletion-impact",
	...e
}), Dr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/labels/{labelId}",
	...e
}), Or = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/labels/{labelId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), kr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/workouts",
	...e
}), Ar = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workouts",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), jr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}",
	...e
}), Mr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}",
	...e
}), Nr = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Pr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}/items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Fr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}/reorder",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ir = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}/copy",
	...e
}), Lr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}/image",
	...e
}), Rr = (e) => (e.client ?? E).put({
	url: "/api/organizations/{organizationId}/workouts/{workoutId}/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), zr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}",
	...e
}), Br = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Vr = (e) => (e.client ?? E).put({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/exercise",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Hr = (e) => (e.client ?? E).put({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/attributes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ur = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/duplicate",
	...e
}), Wr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/alternates",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Gr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/alternates/{alternateId}",
	...e
}), Kr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/workout-items/{workoutItemId}/sets",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qr = (e) => (e.client ?? E).delete({
	url: "/api/organizations/{organizationId}/workout-sets/{workoutSetId}",
	...e
}), Jr = (e) => (e.client ?? E).patch({
	url: "/api/organizations/{organizationId}/workout-sets/{workoutSetId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Yr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/programs",
	...e
}), Xr = (e) => (e.client ?? E).post({
	url: "/api/organizations/{organizationId}/programs",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Zr = (e) => (e.client ?? E).get({
	url: "/api/organizations/{organizationId}/programs/{programId}",
	...e
}), Qr = (e) => (e?.client ?? E).get({
	url: "/api/platform-settings",
	...e
}), $r = (e) => (e?.client ?? E).get({
	url: "/api/products",
	...e
}), ei = (e) => (e?.client ?? E).post({
	url: "/api/products",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), ti = (e) => (e?.client ?? E).get({
	url: "/api/products/options",
	...e
}), ni = (e) => (e.client ?? E).get({
	url: "/api/products/public/{coachSlug}/{productSlug}",
	...e
}), ri = (e) => (e.client ?? E).get({
	url: "/api/products/sales",
	...e
}), ii = (e) => (e.client ?? E).get({
	url: "/api/products/sales/export",
	...e
}), ai = (e) => (e?.client ?? E).get({
	url: "/api/products/fee",
	...e
}), oi = (e) => (e?.client ?? E).delete({
	url: "/api/products/invoicing",
	...e
}), si = (e) => (e?.client ?? E).get({
	url: "/api/products/invoicing",
	...e
}), ci = (e) => (e?.client ?? E).put({
	url: "/api/products/invoicing",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), li = (e) => (e?.client ?? E).post({
	url: "/api/products/invoicing/check",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), ui = (e) => (e?.client ?? E).get({
	url: "/api/products/subscriptions",
	...e
}), di = (e) => (e?.client ?? E).get({
	url: "/api/products/promo-codes",
	...e
}), fi = (e) => (e?.client ?? E).post({
	url: "/api/products/promo-codes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), pi = (e) => (e.client ?? E).post({
	url: "/api/products/promo-codes/{promoCodeId}/deactivate",
	...e
}), mi = (e) => (e?.client ?? E).get({
	url: "/api/products/my-subscriptions",
	...e
}), hi = (e) => (e.client ?? E).post({
	url: "/api/products/my-subscriptions/{productSubscriptionId}/portal",
	...e
}), gi = (e) => (e.client ?? E).get({
	url: "/api/products/athletes/{athleteId}/payments",
	...e
}), _i = (e) => (e.client ?? E).post({
	url: "/api/products/subscriptions/{productSubscriptionId}/cancel",
	...e
}), vi = (e) => (e.client ?? E).post({
	url: "/api/products/payments/{productPaymentId}/refund",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), yi = (e) => (e.client ?? E).post({
	url: "/api/products/payments/{productPaymentId}/invoice",
	...e
}), bi = (e) => (e.client ?? E).get({
	url: "/api/products/payments/{productPaymentId}/stripe-document",
	...e
}), xi = (e) => (e.client ?? E).delete({
	url: "/api/products/{productId}",
	...e
}), Si = (e) => (e.client ?? E).get({
	url: "/api/products/{productId}",
	...e
}), Ci = (e) => (e.client ?? E).patch({
	url: "/api/products/{productId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), wi = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/publish",
	...e
}), Ti = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/pause",
	...e
}), Ei = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/resume",
	...e
}), Di = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/archive",
	...e
}), Oi = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/unarchive",
	...e
}), ki = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/prices",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ai = (e) => (e.client ?? E).delete({
	url: "/api/products/{productId}/prices/{priceId}",
	...e
}), ji = (e) => (e.client ?? E).patch({
	url: "/api/products/{productId}/prices/{priceId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Mi = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/checkout",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ni = (e) => (e.client ?? E).post({
	url: "/api/products/{productId}/checkout/complete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Pi = (e) => (e.client ?? E).get({
	url: "/api/profiles/{slug}/exists",
	...e
}), Fi = (e) => (e?.client ?? E).get({
	url: "/api/profiles/me/slug-suggestion",
	...e
}), Ii = (e) => (e?.client ?? E).get({
	url: "/api/profiles/sitemap",
	...e
}), Li = (e) => (e?.client ?? E).get({
	url: "/api/profiles/me",
	...e
}), Ri = (e) => (e?.client ?? E).get({
	url: "/api/profiles/me/leads",
	...e
}), zi = (e) => (e.client ?? E).put({
	url: "/api/profiles/me/save",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Bi = (e) => (e?.client ?? E).delete({
	url: "/api/profiles/me/avatar",
	...e
}), Vi = (e) => (e.client ?? E).post({
	...t,
	url: "/api/profiles/me/avatar",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Hi = (e) => (e.client ?? E).post({
	...t,
	url: "/api/profiles/me/link-thumbnail",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), Ui = (e) => (e.client ?? E).put({
	url: "/api/profiles/me/links/reorder",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Wi = (e) => (e.client ?? E).delete({
	url: "/api/profiles/me/links/{linkId}",
	...e
}), Gi = (e) => (e.client ?? E).post({
	url: "/api/profiles/{slug}/contact-form/submissions",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ki = (e) => (e.client ?? E).get({
	url: "/api/profiles/{slug}",
	...e
}), qi = (e) => (e?.client ?? E).get({
	url: "/api/programs/phase-structures",
	...e
}), Ji = (e) => (e?.client ?? E).post({
	url: "/api/programs/phase-structures",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Yi = (e) => (e.client ?? E).delete({
	url: "/api/programs/phase-structures/{phaseStructureId}",
	...e
}), Xi = (e) => (e.client ?? E).put({
	url: "/api/programs/phase-structures/{phaseStructureId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Zi = (e) => (e?.client ?? E).get({
	url: "/api/programs/phase-templates",
	...e
}), Qi = (e) => (e?.client ?? E).post({
	url: "/api/programs/phase-templates",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), $i = (e) => (e?.client ?? E).post({
	url: "/api/programs",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), ea = (e) => (e?.client ?? E).get({
	url: "/api/programs/search",
	...e
}), ta = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/week/clear",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), na = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/workouts/bulk-copy",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ra = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/workout-items/bulk-copy",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ia = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/workouts/bulk-delete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), aa = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/workout-items/bulk-delete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), oa = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/week/duplicate",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), sa = (e) => (e.client ?? E).get({
	url: "/api/programs/athlete/{id}/workouts",
	...e
}), ca = (e) => (e.client ?? E).get({
	url: "/api/programs/athlete/{id}/history",
	...e
}), la = (e) => (e.client ?? E).get({
	url: "/api/programs/athlete/{id}",
	...e
}), ua = (e) => (e.client ?? E).get({
	url: "/api/programs/{programId}/workout/{programWorkoutId}",
	...e
}), da = (e) => (e.client ?? E).put({
	url: "/api/programs/{programId}/phases",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), fa = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/replace-exercise",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), pa = (e) => (e.client ?? E).get({
	url: "/api/programs/{id}",
	...e
}), ma = (e) => (e.client ?? E).post({
	url: "/api/programs/workouts/assign",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ha = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/import-program",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ga = (e) => (e.client ?? E).post({
	url: "/api/programs/{programId}/workouts/{programWorkoutId}/export-to-library",
	...e
}), _a = (e) => (e.client ?? E).post({
	url: "/api/programs/assignProgram",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), va = (e) => (e.client ?? E).post({
	url: "/api/programs/copyProgram",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ya = (e) => (e.client ?? E).delete({
	url: "/api/programs/{programId}",
	...e
}), ba = (e) => (e.client ?? E).put({
	url: "/api/programs/{programId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), xa = (e) => (e.client ?? E).delete({
	url: "/api/programs/{programId}/image",
	...e
}), Sa = (e) => (e?.client ?? E).delete({
	url: "/api/push-tokens",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Ca = (e) => (e?.client ?? E).post({
	url: "/api/push-tokens",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), wa = (e) => (e.client ?? E).get({
	url: "/api/push-tokens/status",
	...e
}), Ta = (e) => (e?.client ?? E).get({
	url: "/api/questionnaires/submissions",
	...e
}), Ea = (e) => (e.client ?? E).patch({
	url: "/api/questionnaires/questions/{questionId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Da = (e) => (e.client ?? E).post({
	url: "/api/questionnaires/questions/{questionId}/options",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Oa = (e) => (e.client ?? E).delete({
	url: "/api/questionnaires/options/{optionId}",
	...e
}), ka = (e) => (e.client ?? E).patch({
	url: "/api/questionnaires/options/{optionId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Aa = (e) => (e.client ?? E).delete({
	url: "/api/questionnaires/items/{itemId}",
	...e
}), ja = (e) => (e.client ?? E).patch({
	url: "/api/questionnaires/sections/{sectionId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ma = (e) => (e?.client ?? E).get({
	url: "/api/questionnaires",
	...e
}), Na = (e) => (e?.client ?? E).post({
	url: "/api/questionnaires",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Pa = (e) => (e.client ?? E).get({
	url: "/api/questionnaires/{id}/deletion-impact",
	...e
}), Fa = (e) => (e.client ?? E).post({
	url: "/api/questionnaires/{questionnaireId}/items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ia = (e) => (e.client ?? E).post({
	url: "/api/questionnaires/{questionnaireId}/assign",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), La = (e) => (e.client ?? E).post({
	url: "/api/questionnaires/{questionnaireId}/copy",
	...e
}), Ra = (e) => (e.client ?? E).delete({
	url: "/api/questionnaires/{id}",
	...e
}), za = (e) => (e.client ?? E).get({
	url: "/api/questionnaires/{id}",
	...e
}), Ba = (e) => (e.client ?? E).patch({
	url: "/api/questionnaires/{id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Va = (e) => (e.client ?? E).get({
	url: "/api/questionnaires/submissions/{submissionId}",
	...e
}), Ha = (e) => (e.client ?? E).get({
	url: "/api/questionnaires/{questionnaireId}/submissions",
	...e
}), Ua = (e) => (e?.client ?? E).get({
	url: "/api/resources",
	...e
}), Wa = (e) => (e?.client ?? E).post({
	url: "/api/resources",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Ga = (e) => (e.client ?? E).delete({
	url: "/api/resources/{resourceId}",
	...e
}), Ka = (e) => (e.client ?? E).put({
	url: "/api/resources/{resourceId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qa = (e) => (e.client ?? E).get({
	url: "/api/resources/{resourceId}/deletion-impact",
	...e
}), Ja = (e) => (e?.client ?? E).get({
	url: "/api/settings",
	...e
}), Ya = (e) => (e?.client ?? E).patch({
	url: "/api/settings",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), Xa = (e) => (e?.client ?? E).post({
	url: "/api/stripe-account/connect",
	...e
}), Za = (e) => (e?.client ?? E).post({
	url: "/api/stripe-account/dashboard-link",
	...e
}), Qa = (e) => (e?.client ?? E).post({
	url: "/api/stripe-account/sync",
	...e
}), $a = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/cancel",
	...e
}), eo = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/checkout-session/complete",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), to = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/billing-portal",
	...e
}), no = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/checkout-session",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), ro = (e) => (e?.client ?? E).get({
	url: "/api/subscriptions/overview",
	...e
}), io = (e) => (e?.client ?? E).get({
	url: "/api/subscriptions/coach-profile",
	...e
}), ao = (e) => (e?.client ?? E).get({
	url: "/api/subscriptions/tier",
	...e
}), oo = (e) => (e?.client ?? E).get({
	url: "/api/subscriptions/products",
	...e
}), so = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/update-preview",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), co = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/resume",
	...e
}), lo = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/start-trial",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), uo = (e) => (e?.client ?? E).post({
	url: "/api/subscriptions/update",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e?.headers
	}
}), fo = (e) => (e?.client ?? E).get({
	url: "/api/tasks",
	...e
}), po = (e) => (e?.client ?? E).delete({
	url: "/api/users/avatar",
	...e
}), mo = (e) => (e.client ?? E).post({
	...t,
	url: "/api/users/avatar",
	...e,
	headers: {
		"Content-Type": null,
		...e.headers
	}
}), ho = (e) => (e.client ?? E).post({
	url: "/api/workouts/start-workout",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), go = (e) => (e.client ?? E).post({
	url: "/api/workouts/edit-workout",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), _o = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/sets",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), vo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/alternates",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), yo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/cardio-alternates",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), bo = (e) => (e.client ?? E).put({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/alternates/order",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), xo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/alternates/{alternateId}/make-main",
	...e
}), So = (e) => (e.client ?? E).put({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/exercise",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Co = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/replace-exercise",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), wo = (e) => (e.client ?? E).post({
	url: "/api/workouts/sets/assigned-values/bulk",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), To = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutItemId}/complete-section",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Eo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/copy",
	...e
}), Do = (e) => (e.client ?? E).put({
	url: "/api/workouts/sets/{setId}/attributes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Oo = (e) => (e?.client ?? E).get({
	url: "/api/workouts",
	...e
}), ko = (e) => (e.client ?? E).post({
	url: "/api/workouts",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ao = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/duplicate",
	...e
}), jo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{sectionWorkoutItemId}/rounds/save",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Mo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/save-as-section",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), No = (e) => (e?.client ?? E).get({
	url: "/api/workouts/sections",
	...e
}), Po = (e) => (e.client ?? E).put({
	url: "/api/workouts/{workoutId}/labels",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Fo = (e) => (e.client ?? E).get({
	url: "/api/workouts/v2/{workoutId}",
	...e
}), Io = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}",
	...e
}), Lo = (e) => (e.client ?? E).get({
	url: "/api/workouts/{workoutId}",
	...e
}), Ro = (e) => (e.client ?? E).patch({
	url: "/api/workouts/{workoutId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), zo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/import-section",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Bo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Vo = (e) => (e.client ?? E).post({
	url: "/api/workouts/sets/{workoutSetId}/progress",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ho = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/progress",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Uo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/link-items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Wo = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/move-to-workout",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Go = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/move",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ko = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}/sets/{setId}",
	...e
}), qo = (e) => (e.client ?? E).patch({
	url: "/api/workouts/{workoutId}/sets/{setId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Jo = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}/image",
	...e
}), Yo = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/sets/{setId}",
	...e
}), Xo = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}",
	...e
}), Zo = (e) => (e.client ?? E).patch({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Qo = (e) => (e.client ?? E).delete({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/alternates/{alternateId}",
	...e
}), $o = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/reorder",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), es = (e) => (e.client ?? E).post({
	url: "/api/workouts/{workoutId}/unlink-item",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ts = (e) => (e.client ?? E).patch({
	url: "/api/workouts/sets/{setId}/attributes/{attributeId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ns = (e) => (e.client ?? E).put({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/attributes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), rs = (e) => (e.client ?? E).patch({
	url: "/api/workouts/{workoutId}/workout-items/{workoutItemId}/group",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), is = (e) => (e?.client ?? E).get({
	url: "/api/workflows",
	...e
}), as = (e) => (e.client ?? E).post({
	url: "/api/workflows",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), os = (e) => (e.client ?? E).patch({
	url: "/api/workflows/{workflowId}/schedule/{itemId}/move",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ss = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/schedule/week/clear",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), cs = (e) => (e.client ?? E).delete({
	url: "/api/workflows/{workflowId}/schedule/{itemId}",
	...e
}), ls = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/schedule/week/duplicate",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), us = (e) => (e.client ?? E).get({
	url: "/api/workflows/participants",
	...e
}), ds = (e) => (e.client ?? E).get({
	url: "/api/workflows/workflow-recipients",
	...e
}), fs = (e) => (e.client ?? E).get({
	url: "/api/workflows/{id}/deletion-impact",
	...e
}), ps = (e) => (e.client ?? E).delete({
	url: "/api/workflows/{id}",
	...e
}), ms = (e) => (e.client ?? E).get({
	url: "/api/workflows/{id}",
	...e
}), hs = (e) => (e.client ?? E).patch({
	url: "/api/workflows/{id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), gs = (e) => (e.client ?? E).get({
	url: "/api/workflows/{workflowId}/workout/{programWorkoutId}",
	...e
}), _s = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/import-program",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), vs = (e) => (e.client ?? E).get({
	url: "/api/workflows/{workflowId}/public",
	...e
}), $ = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/join",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ys = (e) => (e.client ?? E).get({
	url: "/api/workflows/{workflowId}/enrollments",
	...e
}), bs = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/enrollments",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), xs = (e) => (e.client ?? E).delete({
	url: "/api/workflows/{workflowId}/enrollments/{enrollmentId}",
	...e
}), Ss = (e) => (e.client ?? E).get({
	url: "/api/workflows/{workflowId}/enrollments/{enrollmentId}",
	...e
}), Cs = (e) => (e.client ?? E).patch({
	url: "/api/workflows/{workflowId}/enrollments/{enrollmentId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), ws = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/enrollments/{enrollmentId}/accept",
	...e
}), Ts = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/enrollments/{enrollmentId}/reject",
	...e
}), Es = (e) => (e.client ?? E).post({
	url: "/api/workflows/{workflowId}/schedule/items",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ds = (e) => (e.client ?? E).patch({
	url: "/api/workflows/{workflowId}/schedule/items/{itemId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Os = (e) => (e.client ?? E).get({
	url: "/api/workflows/schedule-items/{id}",
	...e
}), ks = (e) => (e.client ?? E).post({
	url: "/api/workflows/complete-task",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), As = {
	WARM_UP: "WARM_UP",
	DROP_SET: "DROP_SET",
	FAILURE: "FAILURE"
}, js = {
	NUMBER: "NUMBER",
	TEXT: "TEXT",
	TEMPO: "TEMPO",
	MINUTES: "MINUTES",
	HOURS: "HOURS"
}, Ms = {
	RUNNING: "RUNNING",
	CYCLING: "CYCLING",
	SWIMMING: "SWIMMING",
	WALKING: "WALKING",
	HIKING: "HIKING",
	ROWING: "ROWING",
	OUTDOOR_RUN: "OUTDOOR_RUN",
	INDOOR_RUN: "INDOOR_RUN",
	TRAIL_RUN: "TRAIL_RUN",
	ROAD_BIKE: "ROAD_BIKE",
	INDOOR_BIKE: "INDOOR_BIKE",
	MOUNTAIN_BIKE: "MOUNTAIN_BIKE",
	AIRBIKE: "AIRBIKE",
	POOL_SWIM: "POOL_SWIM",
	OPEN_WATER_SWIM: "OPEN_WATER_SWIM"
}, Ns = {
	WARMUP: "WARMUP",
	ACTIVE: "ACTIVE",
	INTERVAL: "INTERVAL",
	REST: "REST",
	RECOVERY: "RECOVERY",
	COOLDOWN: "COOLDOWN"
}, Ps = {
	TIME: "TIME",
	DISTANCE: "DISTANCE",
	OPEN: "OPEN",
	REPEAT_UNTIL_STEPS_CMPLT: "REPEAT_UNTIL_STEPS_CMPLT"
}, Fs = {
	OPEN: "OPEN",
	PACE: "PACE",
	SPEED: "SPEED",
	HEART_RATE: "HEART_RATE",
	HEART_RATE_PERCENT: "HEART_RATE_PERCENT",
	LTHR_PERCENT: "LTHR_PERCENT",
	HR_ZONE: "HR_ZONE",
	POWER: "POWER",
	POWER_PERCENT: "POWER_PERCENT",
	POWER_ZONE: "POWER_ZONE",
	CADENCE: "CADENCE"
}, Is = {
	TRIALING: "TRIALING",
	ACTIVE: "ACTIVE",
	PAST_DUE: "PAST_DUE",
	CANCELED: "CANCELED",
	UNPAID: "UNPAID",
	INCOMPLETE_EXPIRED: "INCOMPLETE_EXPIRED"
}, Ls = {
	FREE: "FREE",
	PAID: "PAID",
	FREE_BETA: "FREE_BETA",
	TRIAL: "TRIAL"
}, Rs = {
	ADMIN: "ADMIN",
	USER: "USER"
}, zs = {
	NOT_CONNECTED: "NOT_CONNECTED",
	ONBOARDING: "ONBOARDING",
	VERIFYING: "VERIFYING",
	READY: "READY",
	RESTRICTED: "RESTRICTED"
}, Bs = {
	QUEUED: "QUEUED",
	RUNNING: "RUNNING",
	SUCCEEDED: "SUCCEEDED",
	SKIPPED: "SKIPPED",
	FAILED: "FAILED",
	CANCELED: "CANCELED"
}, Vs = {
	LOG_WORKOUT: "LOG_WORKOUT",
	RESCHEDULE: "RESCHEDULE",
	EDIT_WORKOUT: "EDIT_WORKOUT"
}, Hs = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
	PAUSED: "PAUSED",
	ARCHIVED: "ARCHIVED"
}, Us = {
	DAY: "DAY",
	WEEK: "WEEK",
	MONTH: "MONTH",
	YEAR: "YEAR"
}, Ws = {
	NEEDS_RESPONSE: "NEEDS_RESPONSE",
	UNDER_REVIEW: "UNDER_REVIEW",
	WON: "WON",
	LOST: "LOST"
}, Gs = {
	CREDENTIALS_REJECTED: "CREDENTIALS_REJECTED",
	UNAVAILABLE: "UNAVAILABLE",
	UNCONFIRMED: "UNCONFIRMED",
	REJECTED: "REJECTED",
	EMAIL_FAILED: "EMAIL_FAILED",
	STILL_CREATING: "STILL_CREATING",
	NOT_CONNECTED: "NOT_CONNECTED",
	UNEXPECTED: "UNEXPECTED"
}, Ks = {
	INVOICE: "INVOICE",
	RECEIPT: "RECEIPT"
}, qs = {
	RATE_23: "RATE_23",
	RATE_8: "RATE_8",
	RATE_5: "RATE_5",
	RATE_0: "RATE_0",
	EXEMPT: "EXEMPT"
}, Js = {
	TURNOVER_LIMIT: "TURNOVER_LIMIT",
	ACTIVITY_TYPE: "ACTIVITY_TYPE",
	MINISTER_REGULATION: "MINISTER_REGULATION",
	EU_DIRECTIVE: "EU_DIRECTIVE",
	CUSTOM: "CUSTOM"
}, Ys = {
	FAKTUROWNIA: "FAKTUROWNIA",
	INFAKT: "INFAKT"
}, Xs = {
	FIRST_PAYMENT: "FIRST_PAYMENT",
	ALL_PAYMENTS: "ALL_PAYMENTS"
};
//#endregion
export { Bs as AutomationRunStatus, js as ExerciseAttributeType, qs as InvoiceVatRate, Ys as InvoicingProviderKey, Vs as MaterializeWorkoutIntent, Gs as ProductInvoiceError, Ws as ProductPaymentDisputeStatus, Us as ProductPriceInterval, Hs as ProductStatus, Is as ProductSubscriptionStatus, Xs as PromoCodeAppliesTo, Ms as SportType, Ps as StepDurationType, Ns as StepIntensity, Fs as StepTargetType, zs as StripeAccountStatus, Ks as StripeDocumentType, Rs as UserRole, Ls as UserTier, Js as VatExemptionBasis, As as WorkoutSetType, Z as abortAiChat, re as acceptAthleteInvitation, Kn as acceptOrganizationMemberInvitation, ws as acceptWorkflowEnrollmentRequest, yo as addCardioAlternate, ht as addComment, Pn as addMeasurement, $n as addOrganizationAthlete, nr as addOrganizationAthleteMeasurements, Cr as addOrganizationMember, Wr as addOrganizationWorkoutItemAlternate, Kr as addOrganizationWorkoutSet, ki as addProductPrice, _o as addSet, U as addUserFeatureFlag, vo as addWorkoutItemAlternate, A as advanceSubscription, Cn as approveMcpAuthorization, Ae as archiveAthlete, Di as archiveProduct, So as assignExercise, cr as assignOrganizationAthleteQuestionnaire, Vr as assignOrganizationWorkoutItemExercise, _a as assignProgram, Je as assignProgramToCalendar, Ia as assignQuestionnaire, wo as assignSetValues, ma as assignWorkout, Fe as authenticate, Ie as authorize, qe as bulkCopyCalendarWorkout, Qe as bulkCopyCalendarWorkoutItem, na as bulkCopyWorkout, ra as bulkCopyWorkoutItem, Ye as bulkDeleteCalendarItem, Ze as bulkDeleteCalendarWorkoutItem, ia as bulkDeleteWorkout, aa as bulkDeleteWorkoutItem, Xe as bulkMoveCalendarItem, _i as cancelProductSubscription, $a as cancelSubscription, li as checkInvoicingConnection, Pi as checkSlugExists, tt as clearCalendarWeek, ta as clearProgramWeek, ss as clearWorkflowScheduleWeek, E as client, eo as completeCheckoutSession, Ni as completeProductCheckout, To as completeSection, ks as completeWorkflowTask, Zt as connectAppleHealth, Xa as connectStripeAccount, yt as copyContentHub, Lt as copyExercise, hr as copyOrganizationExercise, Ir as copyOrganizationWorkout, va as copyProgram, La as copyQuestionnaire, Eo as copyWorkout, q as createAiChat, F as createAppFeature, xe as createAthleteFilter, ze as createAutomation, to as createBillingPortalSession, Ge as createCalendarItem, rt as createCalendarPhases, no as createCheckoutSession, vt as createContentHub, jt as createContentHubItem, Mt as createContentHubItems, It as createExercise, z as createFeatureFlag, on as createIntegrationMetricConfig, vn as createLabel, An as createMetric, le as createOrGetDirectChat, Jn as createOrganization, mr as createOrganizationExercise, Tr as createOrganizationLabel, Xr as createOrganizationProgram, Ar as createOrganizationWorkout, Ji as createPhaseStructure, Qi as createPhaseTemplate, ei as createProduct, Mi as createProductCheckout, hi as createProductPortalSession, $i as createProgram, fi as createPromoCode, Na as createQuestionnaire, Fa as createQuestionnaireItem, Da as createQuestionnaireQuestionOption, Wa as createResource, mn as createStravaWebhookSubscription, Za as createStripeDashboardLink, Do as createUpdateAttributeValue, as as createWorkflow, bs as createWorkflowEnrollment, Es as createWorkflowScheduleItem, ko as createWorkout, pi as deactivatePromoCode, I as deleteAppFeature, Se as deleteAthleteFilter, Ve as deleteAutomation, it as deleteCalendarPhase, ae as deleteChatMedia, pe as deleteChatMessage, bt as deleteContentHub, Ot as deleteContentHubItem, Rt as deleteExercise, B as deleteFeatureFlag, sn as deleteIntegrationMetricConfig, oi as deleteInvoicingIntegration, gr as deleteOrganizationExercise, Yi as deletePhaseStructure, xi as deleteProduct, Bi as deleteProfileAvatar, Wi as deleteProfileLink, ya as deleteProgram, Ra as deleteQuestionnaire, Aa as deleteQuestionnaireItem, Oa as deleteQuestionnaireQuestionOption, Ga as deleteResource, fn as deleteStravaWebhookSubscription, ps as deleteWorkflow, xs as deleteWorkflowEnrollment, cs as deleteWorkflowScheduleItem, wn as denyMcpAuthorization, dt as discardCalendarItem, $t as disconnectAppleHealth, un as disconnectStrava, et as duplicateCalendarWeek, Ur as duplicateOrganizationWorkoutItem, oa as duplicateProgramWeek, ls as duplicateWorkflowScheduleWeek, Ao as duplicateWorkoutItem, me as editChatMessage, ji as editProductPrice, go as editWorkout, $e as exportCalendarWorkoutToLibrary, ga as exportProgramWorkoutToLibrary, ft as finishCalendarItem, J as getAiChat, Bn as getAllNotifications, Q as getAppRelease, Qt as getAppleHealthConfig, en as getAppleHealthStatus, la as getAthleteAssignedProgram, ca as getAthleteAssignedProgramHistory, sa as getAthleteAssignedProgramWorkouts, Ke as getAthleteCalendar, ye as getAthleteDashboard, ne as getAthleteInvitation, Ee as getAthleteProfile, Oe as getAthleteProgram, Ce as getAthletes, Le as getAuthenticationStatus, mt as getAuthorComments, He as getAutomation, ro as getBillingOverview, We as getCalendar, lt as getCalendarItem, ue as getChat, de as getChatMessages, xt as getCoachContentHub, _t as getCoachContentHubs, io as getCoachProfile, ao as getCoachTier, pt as getComments, Dt as getContentHub, wt as getContentHubAssignments, Ct as getContentHubDeletionImpact, kt as getContentHubItem, Et as getContentHubs, zt as getExerciseById, Ut as getExerciseCategories, Kt as getExerciseHistory, an as getIntegrationMetricConfigs, rn as getIntegrationStatuses, si as getInvoicingIntegration, yn as getLabelDeletionImpact, _n as getLabels, Sn as getMcpAuthorization, Mn as getMetricMeasurements, Nn as getMetricSeries, Dn as getMetricsAvailable, On as getMetricsSummary, oe as getMyChats, Ln as getMyMetrics, Li as getMyProfile, Vn as getNotification, Rn as getNotificationPreferences, ir as getOrganizationAthleteExerciseHistory, tr as getOrganizationAthleteMetricSeries, er as getOrganizationAthleteMetrics, ur as getOrganizationAthleteProfile, lr as getOrganizationAthleteQuestionnaireSubmission, _r as getOrganizationExercise, Er as getOrganizationLabelDeletionImpact, Gn as getOrganizationMemberInvitation, Zr as getOrganizationProgram, Mr as getOrganizationWorkout, Qr as getPlatformSettings, ce as getPossibleChatParticipants, Si as getProduct, bi as getProductPaymentStripeDocument, ri as getProductSales, ii as getProductSalesExport, ai as getProductsFee, Ki as getProfile, Ii as getProfileSitemap, Fi as getProfileSlugSuggestion, pa as getProgram, ua as getProgramWorkout, ni as getPublicProduct, vs as getPublicWorkflow, za as getQuestionnaire, Pa as getQuestionnaireDeletionImpact, qa as getResourceDeletionImpact, Ua as getResources, Ja as getSettings, hn as getStravaActivities, gn as getStravaActivityDetail, cn as getStravaConnectUrl, ln as getStravaStatus, pn as getStravaWebhookSubscription, Va as getSubmission, wa as getTokenStatus, ms as getWorkflow, fs as getWorkflowDeletionImpact, Ss as getWorkflowEnrollment, us as getWorkflowParticipants, ds as getWorkflowRecipients, Os as getWorkflowScheduleItem, gs as getWorkflowWorkout, Lo as getWorkout, Fo as getWorkoutV2, ha as importProgramToProgram, _s as importProgramToWorkflow, zo as importSection, Pr as insertOrganizationWorkoutItem, Bo as insertWorkoutItem, _e as inviteAthlete, $ as joinWorkflow, Uo as linkWorkoutItems, G as listAdminUsers, K as listAiChats, P as listAppFeatures, be as listAthleteFilters, gi as listAthleteProductPayments, ke as listAthleteQuestionnaire, Ta as listAthleteQuestionnaireSubmissions, Be as listAutomationRuns, Re as listAutomations, D as listBillingCatalog, oo as listBillingProducts, nt as listCalendarPhases, M as listCoachProductsFees, Wt as listExerciseAttributes, Ft as listExercises, R as listFeatureFlags, Tn as listMcpConnections, kn as listMetrics, Ht as listMovementPatterns, Vt as listMuscleGroups, se as listMyChats, mi as listMyProductSubscriptions, or as listOrganizationAthleteAvailableQuestionnaires, sr as listOrganizationAthleteQuestionnaireSubmissions, ar as listOrganizationAthleteQuestionnaires, Qn as listOrganizationAthletes, pr as listOrganizationExercises, wr as listOrganizationLabels, Sr as listOrganizationMembers, Yr as listOrganizationPrograms, kr as listOrganizationWorkouts, qn as listOrganizations, qi as listPhaseStructures, Zi as listPhaseTemplates, ti as listProductOptions, ui as listProductSubscriptions, $r as listProducts, Ri as listProfileLeads, di as listPromoCodes, Ha as listQuestionnaireSubmission, Ma as listQuestionnaires, No as listSections, fo as listTasks, H as listUserFeatureFlags, ys as listWorkflowEnrollments, is as listWorkflows, Oo as listWorkouts, Vo as logSetProgress, Ho as logWorkoutProgress, xo as makeWorkoutItemAlternateMain, Wn as markAllNotificationsAsRead, he as markChatAsRead, ge as markChatAsUnread, gt as markCommentsAsRead, Hn as markNotificationAsRead, Un as markNotificationAsUnread, ot as materializeCalendarItem, ct as moveCalendarItem, Pt as moveContentHubItem, os as moveWorkflowScheduleItem, Go as moveWorkoutItem, Wo as moveWorkoutItemToWorkout, Ti as pauseProduct, so as previewSubscriptionUpdate, wi as publishProduct, vi as refundProductPayment, Me as register, Ca as registerPushToken, Ts as rejectWorkflowEnrollmentRequest, qt as removeExerciseImage, bn as removeLabel, Fn as removeMeasurement, yr as removeOrganizationExerciseImage, Dr as removeOrganizationLabel, Xn as removeOrganizationLogo, jr as removeOrganizationWorkout, Lr as removeOrganizationWorkoutImage, zr as removeOrganizationWorkoutItem, Gr as removeOrganizationWorkoutItemAlternate, qr as removeOrganizationWorkoutSet, Ai as removeProductPrice, xa as removeProgramImage, Ko as removeSet, po as removeUserAvatar, Io as removeWorkout, Yo as removeWorkoutExerciseSet, Jo as removeWorkoutImage, Xo as removeWorkoutItem, Qo as removeWorkoutItemAlternate, Nt as reorderContentHubItems, Fr as reorderOrganizationWorkoutItems, Ui as reorderProfileLinks, bo as reorderWorkoutItemAlternates, $o as reorderWorkoutItems, Co as replaceExercise, fa as replaceProgramExercise, da as replaceProgramPhases, Ne as requestPasswordReset, yi as requestProductInvoice, je as restoreAthlete, Ei as resumeProduct, co as resumeSubscription, En as revokeMcpConnection, Sa as revokePushToken, W as revokeUserFeatureFlag, zi as saveProfile, jo as saveSectionRoundSets, Mo as saveWorkoutItemAsSection, Gt as searchExerciseHistory, rr as searchOrganizationAthleteExerciseHistory, ea as searchPrograms, Y as sendAiChatMessage, fe as sendChatMessage, we as setAthleteLabels, st as setCalendarVisibility, Jt as setExerciseAlternates, fr as setOrganizationAthleteLabels, Rr as setOrganizationWorkoutLabels, Po as setWorkoutLabels, lo as startTrial, ho as startWorkout, X as streamAiChat, Gi as submitProfileContactForm, tn as syncAppleHealth, nn as syncAppleHealthWorkouts, O as syncBillingCatalog, dn as syncStrava, Qa as syncStripeAccount, Oi as unarchiveProduct, es as unlinkWorkoutItem, L as updateAppFeature, Te as updateAthlete, De as updateAthleteProfile, ts as updateAttributeValue, Ue as updateAutomation, k as updateBillingProduct, ut as updateCalendarItem, at as updateCalendarPhase, ve as updateCoach, N as updateCoachProductsFee, St as updateContentHub, Tt as updateContentHubAssignments, At as updateContentHubItem, Bt as updateExercise, V as updateFeatureFlag, ci as updateInvoicingIntegration, xn as updateLabel, In as updateMeasurement, jn as updateMetric, zn as updateNotificationPreferences, Yn as updateOrganization, dr as updateOrganizationAthleteProfile, vr as updateOrganizationExercise, Or as updateOrganizationLabel, Nr as updateOrganizationWorkout, Br as updateOrganizationWorkoutItem, Hr as updateOrganizationWorkoutItemAttributes, Jr as updateOrganizationWorkoutSet, Xi as updatePhaseStructure, j as updatePlatformSettings, Ci as updateProduct, ba as updateProgram, Ba as updateQuestionnaire, Ea as updateQuestionnaireQuestion, ka as updateQuestionnaireQuestionOption, ja as updateQuestionnaireSection, Ka as updateResource, qo as updateSet, Ya as updateSettings, uo as updateSubscription, hs as updateWorkflow, Cs as updateWorkflowEnrollment, Ds as updateWorkflowScheduleItem, Ro as updateWorkout, Zo as updateWorkoutItem, ns as updateWorkoutItemAttributes, rs as updateWorkoutItemGroup, ie as uploadChatMedia, Yt as uploadExerciseImage, Xt as uploadExerciseVideo, br as uploadOrganizationExerciseImage, xr as uploadOrganizationExerciseVideo, Zn as uploadOrganizationLogo, Vi as uploadProfileAvatar, Hi as uploadProfileLinkThumbnail, mo as uploadUserAvatar, Pe as verifyEmail };

//# sourceMappingURL=index.js.map